
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const MinusIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M84 48C84 49.933 82.433 51.5 80.5 51.5L15.5 51.5C13.567 51.5 12 49.933 12 48C12 46.067 13.567 44.5 15.5 44.5L80.5 44.5C82.433 44.5 84 46.067 84 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M84 48C84 49.933 82.433 51.5 80.5 51.5L15.5 51.5C13.567 51.5 12 49.933 12 48C12 46.067 13.567 44.5 15.5 44.5L80.5 44.5C82.433 44.5 84 46.067 84 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M84 48C84 49.933 82.433 51.5 80.5 51.5L15.5 51.5C13.567 51.5 12 49.933 12 48C12 46.067 13.567 44.5 15.5 44.5L80.5 44.5C82.433 44.5 84 46.067 84 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M84 48C84 49.933 82.433 51.5 80.5 51.5L15.5 51.5C13.567 51.5 12 49.933 12 48C12 46.067 13.567 44.5 15.5 44.5L80.5 44.5C82.433 44.5 84 46.067 84 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
